// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProductsSegmentMultipleChart-module__hidden--Zyhsx{display:none}`, "",{"version":3,"sources":["webpack://./src/data-visualization/products-segment-mulitple-chart/ProductsSegmentMultipleChart.module.scss"],"names":[],"mappings":"AAAA,oDACE,YAAA","sourcesContent":[".hidden {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export var hidden = `ProductsSegmentMultipleChart-module__hidden--Zyhsx`;
export default ___CSS_LOADER_EXPORT___;
